__turbopack_context__.v({
  "hoverable_opacity": "CartLink-module__x_MTfG__hoverable_opacity",
});
